import GetCallLogByIdRequestModelBase from '../_generated/modelBases/get-call-log-by-id-request-model-base';

export default class GetCallLogByIdRequestModel extends GetCallLogByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
